import { render } from "./preparePackage.vue?vue&type=template&id=04dd87a4&scoped=true"
import script from "./preparePackage.vue?vue&type=script&lang=js"
export * from "./preparePackage.vue?vue&type=script&lang=js"

import "./preparePackage.vue?vue&type=style&index=0&id=04dd87a4&lang=scss&scoped=true"
import "./preparePackage.vue?vue&type=style&index=1&id=04dd87a4&lang=scss"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dd87a4"]])

export default __exports__